module.exports = __webpack_public_path__ + "static/media/beer.9d057b2b.svg";